import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
export default class AutomationID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
